<header [preLogin]="false"></header>
<div class="post-login-1">
    <div class="post-login-1-col-1 h-100">
        <app-left-panel-prelogin activeTab="1" *ngIf="!this.auth?.detailuser"></app-left-panel-prelogin>
        <left-panel activeTab="5" *ngIf="this.auth?.detailuser"></left-panel>
    </div>
    <div class="post-login-1-col-2 pt-70-pb-70-pr-40 p-mobile-15">
        <div class="onboarding-canvas h-500">
            <grid-row class="justify-content-center align-content-between h-100">
                <grid-col col="12">
                    <grid-row class="mt-30 align-item-center col-space">
                        <grid-col col="2" mobile="3">
                            <ng-icon iconClass="icon-email-otp bg-nuetral-primary br-8 p-14" width="56"
                                height="56"></ng-icon>
                        </grid-col>
                        <grid-col col="10" mobile="9">
                              <div class="color-base-700 font-size-20px font-400 line-h-25">
                               {{ "Enter6digit" | translate }}
                              </div>
                            
                                <div class="color-primary font-size-16px font-400 line-h-25">
                                    {{this.userEmail}}
                                </div>
                                    <div class="color-primary font-size-16px font-400 line-h-25">
                                        {{ "Or" | translate }}
                                </div>
                                    <div class="color-primary font-size-16px font-400 line-h-25">
                                    {{this.userMobile}}
                                </div>
                        </grid-col>
                    </grid-row>
                </grid-col>
                <grid-col col="12">
                    <grid-row class="mt-50 justify-content-center text-align-center">
                        <grid-col col="12">
                            <div class="form-group">

                                <ng-otp-input (onInputChange)="onOtpChange($event)" (keydown)="onKeyDown($event)"
                                    allowNumbersOnly="true"
                                    [config]="{length:6, allowNumbersOnly:true, isPasswordInput:true, inputStyles: {'inputmode': 'numeric'}}">
                                </ng-otp-input>


                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="justify-content-center align-item-center mt-50">
                        <grid-col col="auto" *ngIf="!OptTimerbtnShow">
                            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15 link" (click)="ResendOtp()">
                                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                                    {{ "Resend" | translate }}
                                </div>
                            </div>
                        </grid-col>
                        <grid-col col="auto" *ngIf="OptTimerbtnShow">
                            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15">
                                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                                    {{ "Resend" | translate }}
                                    <span *ngIf="true"
                                        class="font-600 font-size-12px color-primary letter-spacing-1">{{timerexpire}}</span>
                                </div>
                            </div>
                        </grid-col>

                    </grid-row>
                </grid-col>
                <grid-col col="12">
                    <grid-row class="justify-content-center mt-50 mb-30">

                        <grid-col col="12"
                            *ngIf="(this.NewEMail == undefined || this.NewEMail == '') && ( this.NewMOb == undefined || this.NewMOb == '') ">
                            <button class="btn-dft mt-20" (click)="Next()" [disabled]="isValid()">
                                {{ "Verify" | translate }}
                            </button>

                        </grid-col>
                        <grid-col col="12"
                            *ngIf="(this.NewEMail != undefined && this.NewEMail != '' )||( this.NewMOb != undefined && this.NewMOb!= '')  ">
                            <button class="btn-dft mt-20" (click)="Next()" [disabled]="isValid()">
                                {{ "Next" | translate }}
                            </button>

                        </grid-col>
                    </grid-row>
                </grid-col>
            </grid-row>
        </div>
    </div>
</div>